export function injectScope(scope: string, targetEnum: any): void {
  const record = new Set();
  Object.keys(targetEnum).forEach((key) => {
    if (scope) {
      targetEnum[key] = `${scope}^_^${targetEnum[key]}`;
    }
    if (process.env.REACT_APP_ENV !== "production") {
      if (record.has(targetEnum[key])) {
        console.log(
          `%c[Duplicate Key]: ${targetEnum[key]} in scope ${scope} duplicated`,
          "color:orange",
        );
      } else {
        record.add(targetEnum[key]);
      }
    }
  });
  record.clear();
}
